import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import { subscribe } from 'app/helpers/cable';

export type State = {
  state: string;
  comment: string | null;
};

const UserToUserTransferState: FC<{
  transferId: string;
  locales: Locales;
  processingImageUrl: string;
}> = ({ transferId, locales, processingImageUrl }) => {
  const [state, setState] = useState<State>({ state: 'unknown', comment: null });

  useEffect(() => {
    const { subscription, unsubscribe } = subscribe(
      {
        channel: 'UserToUserTransferStateChannel',
        transfer_id: transferId,
      },
      {
        connected: () => {
          subscription.perform('send_state');
        },
        received: (data: State) => {
          setState(data);
        },
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  if (['failed', 'success'].includes(state.state))
    return (
      <div>
        <h2 className="title">{translation(locales, state.state)}</h2>
        <span>{state.comment}</span>
      </div>
    );

  return (
    <div>
      <h2 className="title">{translation(locales, 'processing')}</h2>
      <img alt="processing" src={processingImageUrl} />
    </div>
  );
};

export default UserToUserTransferState;
